export interface IPublishedDetails {
  hasNotificationHistory: boolean;
  id:string | null;
  appPublished: boolean;
  isPublished: boolean;
  listId: null;
  reach: number;
  scheduledArchiveDate: string;
  scheduledNotifications: IScheduledNotifications[];
  scheduledPublishDate: string;
}

export interface IScheduledNotifications {
  id: number;
  scheduledPushTime: string;
}

export interface ICreateSchedulePush {
    id: number
    notificationType: number
    scheduledPushTime: string
    contentId: number
    listId: number
    message: string
    reach: number
    appGuid: string
}

export interface IGetNotificationHistory {
  sortBy:
    | "author"
    | "type"
    | "created"
    | "sent"
    | "status"
    | "reach";
  sortType: "Asc" | "Desc";
  top: number;
  skip: number;
}

export interface INotificationHistory {
  items: INotificationHistoryItem[];
  totalItems: number;
  nextSkip: number;
  previousSkip: number;
}

export interface INotificationHistoryItem {
  id: number;
  contentId: number,
  message?: string;
  author: string;
  type: number;
  dateCreated: string;
  dateSent: string;
  status: number;
  audienceReach: number;
}


export enum ScheduleType {
  NOW = "NOW",
  PUBLISH = "PUBLISH",
  CHOOSE = "CHOOSE"
}